import React, { useEffect } from 'react';
import './Map.scss';
import Breadcrumb from '../../components/common/Breadcrumb';
import { FiMapPin, FiPhone, FiMail } from 'react-icons/fi';
import { useLocation, useNavigate } from 'react-router-dom';

const Map = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => (location.pathname === path ? 'active' : '');

  // 카카오 지도 좌표 설정
  const LAT = 37.16125;
  const LNG = 126.963;

  useEffect(() => {
    const { kakao } = window;
    if (!kakao) return;

    const container = document.getElementById('kakao-map');
    const options = {
      center: new kakao.maps.LatLng(LAT, LNG),
      level: 3,
    };

    const map = new kakao.maps.Map(container, options);

    const markerPosition = new kakao.maps.LatLng(LAT, LNG);
    const marker = new kakao.maps.Marker({
      position: markerPosition,
    });
    marker.setMap(map);

    const iwContent = `
      <div style="padding:5px; font-size:12px; text-align:center; width:150px;">
        <strong>베스트트레이딩</strong>
      </div>
    `;
    const infowindow = new kakao.maps.InfoWindow({
      content: iwContent,
    });
    infowindow.open(map, marker);

    const handleResize = () => {
      map.setCenter(new kakao.maps.LatLng(LAT, LNG));
    };
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="sub-page map-technical-v2">
      <section className="sub-visual about">
        <div className="container">
          <div className="visual-header">
            <span className="sub-title">DIRECTIONS</span>
            <h1>LOCATION</h1>
            <p>베스트트레이딩 오시는 길</p>
          </div>
        </div>
      </section>

      <Breadcrumb />

      <nav className="category-nav">
        <div className="container">
          <div className="nav-inner">
            <button className={isActive('/about/greeting')} onClick={() => navigate('/about/greeting')}>
              인사말
            </button>
            <button className={isActive('/about/map')} onClick={() => navigate('/about/map')}>
              찾아오시는 길
            </button>
            <button className={isActive('/about/intro')} onClick={() => navigate('/about/intro')}>
              회사소개서
            </button>
          </div>
        </div>
      </nav>

      <div className="content-main">
        {/* 가로폭 확장을 위해 전용 컨테이너 클래스 사용 */}
        <div className="container-wide">
          <div className="location-card">
            {/* 1. 지도 영역 */}
            <div className="map-wrapper">
              <div className="map-canvas">
                <div id="kakao-map" style={{ width: '100%', height: '100%' }}>
                  <div className="map-placeholder">
                    <span>지도 엔진 로딩 중...</span>
                  </div>
                </div>

                <div className="map-nav-float">
                  <a
                    href={`https://map.kakao.com/link/to/베스트트레이딩,${LAT},${LNG}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="nav-item kakao"
                  >
                    카카오맵 길찾기
                  </a>
                  <a
                    href={`https://map.naver.com/v5/search/경기도 화성시 정남면 서봉로 921번길 76-48`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="nav-item naver"
                  >
                    네이버 지도
                  </a>
                </div>
              </div>
            </div>

            {/* 2. 하단 정보 영역 */}
            <div className="info-grid-section">
              {/* 주소 */}
              <div className="info-col">
                <div className="label">
                  <FiMapPin /> 주소
                </div>
                <div className="value">
                  <p>경기도 화성시 정남면 서봉로 921번길 76-48</p>
                  <span className="sub">본사 및 제1공장 (BEST TRADING HQ)</span>
                </div>
              </div>

              {/* 연락처 */}
              <div className="info-col">
                <div className="label">
                  <FiPhone /> 연락처
                </div>
                <div className="value">
                  <div className="data-row">
                    <span className="type">TEL</span>
                    <span className="num">031-366-0666</span>
                  </div>
                  <div className="data-row">
                    <span className="type">FAX</span>
                    <span className="num">0504-035-1485</span>
                  </div>
                </div>
              </div>

              {/* 고객문의 */}
              <div className="info-col">
                <div className="label">
                  <FiMail /> 고객문의
                </div>
                <div className="value">
                  <div className="data-row single-row">
                    <span className="type">E-MAIL</span>
                    <span className="num">oy7112@gmail.com</span>
                  </div>
                  <div className="data-row single-row">
                    <span className="sub-desc">견적 및 샘플 요청 시 위 메일로 문의 바랍니다.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Map;
